import { render } from "./ChooseVehiclePage.vue?vue&type=template&id=4cf2bbbe&ts=true"
import script from "./ChooseVehiclePage.vue?vue&type=script&lang=ts"
export * from "./ChooseVehiclePage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__